import React from "react";
import { useTranslation } from "react-i18next";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import { IndicatorsList } from "./indicatorsList";
import styles from "./styles.scss";

function Report(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.report}>
      <div className={styles.nameBox}>
        <Skeleton className={styles.projectName} />
        <span className={styles.separator}>&gt;</span>
        <Skeleton className={styles.reportName} />
      </div>
      <div className={styles.row}>
        <Skeleton className={styles.label} />
        <div className={styles.author}>
          <Skeleton className={styles.authorAvatar} />
          <Skeleton className={styles.authorName} />
        </div>
      </div>
      <div className={styles.row}>
        <Skeleton className={styles.label} />
        <Skeleton className={styles.text} />
      </div>
      <div className={styles.row}>
        <Skeleton className={styles.label} />
        <Skeleton className={styles.text} />
      </div>
      <div className={styles.indicators}>
        <IndicatorsList />
      </div>
    </div>
  );
}

export { Report };
